export default "__VITE_ASSET__Bl83M8Ji__"